import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {Stage} from 'vexpo-components';

/** @class StagePreview
  * A component to display a prepared Stage
  * @prop {string} identifier - a unique identifier for the stage
  * @prop {number} width - the width of the stage, in pixels
  * @prop {number} height - the height of the stage in pixels
  * @prop {object} layers - the stage's layers.
  */
export default class StagePreview extends Component {
  /** @constructor
    * Creates a new instance of StagePreview
    */
  constructor(props) {
    super(props);
    this.state = {
      stage: {
        identifier: "loading...",
        width: 0,
        height: 0,
        layers: []
      }
    }
    this.dataRef = firebase.database()
    .ref(`/expos/${props.expoID}/shows/${props.showID}/${props.location}/stage`);
  }
  /** @method componentWillMount()
    * Loads the stage data from Firebase and transforms
    * it for consumption by a Stage Vexpo Component.
    */
  componentWillMount() {
    this.dataRef.on('value', (snapshot) => {
      const data = snapshot.val();
      var stage = {
        identifier: snapshot.key,
        width: data.width,
        height: data.height,
        layers: []
      }
      for(var key in data.layers) {
        stage.layers.push(data.layers[key]);
      }
      stage.layers = stage.layers.sort((a,b) => {return a.order - b.order});
      this.setState({stage: stage});
    });
  }
  /** @method componentWillUnmount
    * Terminates the connection with the Firebase database
    */
  componentWillUnmount() {
    this.dataRef.off()
  }
  /** @method render
    * Renders the stage
    */
  render() {
    return <Stage {...this.state.stage}/>
  }
}



// WEBPACK FOOTER //
// ./src/stage-preview/stage-preview.js